import { isFunction } from 'lodash';

/**
 * returns if the window is defined, used for determining browser vs node
 */
export var HAS_WINDOW = typeof window !== 'undefined';

/**
 * Safely gets a property from the window object
 * @param {string} key property on window to retrieve
 */
export function getWindowObject(key) {
  return HAS_WINDOW && window[key];
}

/**
 * Safely checks if the window exists and supports eventListeners
 */
export var HAS_WINDOW_LISTENERS = !!getWindowObject('addEventListener');

/**
 * Safely check if the window exists and supports form data
 */
export var HAS_FORM_DATA = !!getWindowObject('FormData');

var MIN_DEVICE_MEDIA_QUERY = '(-webkit-min-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx)';

/**
 * Safely, determine if the device has a retina screen
 */
export var hasRetinaScreen = function hasRetinaScreen() {
  return HAS_WINDOW && window.matchMedia(MIN_DEVICE_MEDIA_QUERY).matches;
};

/**
 * Check if argument is thenable
 *
 * @param {any} promise
 */
export var isThenable = function isThenable(promise) {
  return !!(promise && isFunction(promise.then) && isFunction(promise.catch));
};